var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { useEventComposerGlobalContext } from '../../../composers/EventComposerGlobalContext';
import { useConfig } from '../../../context/ConfigContext';
import { useEventApi } from '../../../hooks/useEvent/useEventApi';
function spaceApiToSpace(space) {
    var _a;
    return {
        id: space.id,
        name: space.name,
        locationId: space.location_id,
        levelId: space.level_id,
        isManaged: space.is_managed,
        amenities: space.space_amenities.map(function (amenity) { return ({
            id: amenity.id,
            quantity: amenity.quantity,
            amenityId: amenity.amenity_id,
            name: amenity.amenity.name,
        }); }),
        description: space.description,
        capacity: space.capacity,
        image: space.image,
        permissions: space.permissions,
        calendar: space.calendar
            ? {
                calendarId: space.calendar.calendar_id,
                createdAt: space.calendar.created_at,
                remoteType: space.calendar.remote_type,
                spaceId: space.calendar.space_id.toString(),
                spaceResourceEmail: space.calendar.space_resource_email,
            }
            : null,
        settings: (_a = space.settings) === null || _a === void 0 ? void 0 : _a.map(function (setting) { return ({
            name: setting.name,
            slug: setting.slug,
            value: setting.value,
        }); }),
    };
}
export function useFetchInitialSpaceForComposer(_a) {
    var mainSpaceId = _a.mainSpaceId;
    var _b = useFormContext(), setValue = _b.setValue, getValues = _b.getValues;
    var _c = useEventComposerGlobalContext(), onError = _c.onError, levelId = _c.levelId, locationId = _c.locationId, setLevelId = _c.setLevelId, setLocationId = _c.setLocationId;
    var _d = useConfig(), tenantId = _d.tenantId, environmentUrls = _d.environmentUrls, userContext = _d.userContext, accessToken = _d.accessToken;
    var apiUrl = environmentUrls.apiUrl, baseApiUrl = environmentUrls.baseApiUrl;
    var currentOrg = userContext.currentOrg;
    var fetchSpace = useEventApi({
        onError: onError,
        apiUrl: apiUrl,
        baseApiUrl: baseApiUrl,
        currentOrg: currentOrg,
        tenantId: tenantId,
        accessToken: accessToken,
    }).fetchSpace;
    var _e = __read(useState(false), 2), fetchingSpace = _e[0], setFetchingSpace = _e[1];
    useEffect(function () {
        var _a;
        if (!mainSpaceId)
            return;
        // Only seed the initial space when it isn't already on the form.
        // Without this, switching buildings in the add-space drawer re-triggers
        // this effect and clobbers a just added space with the original seed space.
        var currentSpaces = (_a = getValues('spaces')) !== null && _a !== void 0 ? _a : [];
        if (currentSpaces.some(function (s) { return s.id.toString() === mainSpaceId; }))
            return;
        setFetchingSpace(true);
        fetchSpace({ spaceId: mainSpaceId })
            .then(function (space) {
            var _a;
            if (!space)
                return;
            // Reread after the async gap. skip if the seed already landed, or was
            // added, while the fetch was in flight. Otherwise, prepend it as the
            // primary space without clobbering any concurrently added spaces.
            var spaces = (_a = getValues('spaces')) !== null && _a !== void 0 ? _a : [];
            if (spaces.some(function (s) { return s.id.toString() === mainSpaceId; }))
                return;
            setValue('spaces', __spreadArray([spaceApiToSpace(space)], __read(spaces), false));
            if (!levelId && space.level_id != null) {
                setLevelId(String(space.level_id));
            }
            if (!locationId && space.location_id != null) {
                setLocationId(String(space.location_id));
            }
        })
            .finally(function () {
            setFetchingSpace(false);
        });
    }, [
        mainSpaceId,
        fetchSpace,
        setValue,
        getValues,
        levelId,
        locationId,
        setLevelId,
        setLocationId,
    ]);
    return { fetchingSpace: fetchingSpace };
}
